const MiniLoading = () => {

    return (
        <svg width="64px" height="64px" viewBox="0 0 20 20" fill="fill-darkBlue" className={`absolute top-[50%] left-[50%] h-[32px] w-[32px] ml-[-16px] mt-[-16px] animate-spin`}>
            <g id="SVGRepo_bgCarrier" strokeWidth="4"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">  
                <g id="🔍-System-Icons" stroke="none" strokeWidth="4" fill="none" fillRule="evenodd"> 
                    <g id="ic_fluent_spinner_ios_20_regular" fill="#212E35" fillRule="nonzero"> 
                        <path d="M10,3 C6.13401,3 3,6.13401 3,10 C3,10.2761 2.77614,10.5 2.5,10.5 C2.22386,10.5 2,10.2761 2,10 C2,5.58172 5.58172,2 10,2 C14.4183,2 18,5.58172 18,10 C18,14.4183 14.4183,18 10,18 C9.72386,18 9.5,17.7761 9.5,17.5 C9.5,17.2239 9.72386,17 10,17 C13.866,17 17,13.866 17,10 C17,6.13401 13.866,3 10,3 Z" id="🎨-Color"> </path>
                    </g>
                </g>
            </g>
            </svg>
    )
}
export default MiniLoading;